<template>
  <b-form-group label="RUT" :description="description" :label-size="size">
    <b-form-input
      v-bind="$attrs"
      :value="displayValue"
      :maxlength="9"
      @input="handleInput"
      @focus="handleFocus"
      @blur="handleBlur"
      @keypress="validateRut"
      type="text"
      :size="size"
      inputmode="numeric"
      :required="required"
    ></b-form-input>
  </b-form-group>
</template>

<script>
import { formatRut, validateRut } from '@/plugins/complianceScripts/index.js'

export default {
  name: "RutInput",

  inheritAttrs: false,

  props: {
    value: {
      type: String,
      required: true
    },
    size: {
      type: String,
      default: 'md'
    },
    required: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      isFocused: false,
      internalValue: this.value,
    }
  },

  computed: {
    displayValue() {
      return this.isFocused ? this.focusedValue : this.unfocusedValue
    },
    unfocusedValue() {
      return formatRut(this.internalValue)
    },
    focusedValue() {
      return this.internalValue
    },

    description() {
      return this.isFocused ? 'Ingrese solo los dígitos, sin puntos ni guiones.' : null
    }
  },

  watch: {
    value(newValue) {
      this.internalValue = newValue;
    }
  },

  methods: {
    validateRut, 
    handleInput(newValue) {
      this.internalValue = newValue;
      this.$emit('input', newValue)
    },

    handleFocus() {
      this.isFocused = true
    },

    handleBlur() {
      this.isFocused = false
    },
  }
}
</script>

<style scoped>
input {
  font-family: Courier-New, monospace;
}
</style>
